import { Flex, Text, Box } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { BXInput, BXButton } from "@/styles";
import { useMemo, useState } from "react";
import BXNSelect from "@/components/ui/WSelect";
import { useNavigate } from "react-router-dom";
import { toastTip } from "@/components/ui/toast";
import BalanceModal from "./BalanceModal";

const Create = ({
  tagLabelValue,
  setTagLabelValue,
  setCurrStep,
  ADD_STEP,
  selectedOpt,
  setSelectedOpt,
}) => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [showBalanceTip, setShowBalanceTip] = useState(false);

  const MOCK_SUBACCOUNT = [
    {
      label: "mock1",
      value: 1,
    },

    {
      label: "mock2",
      value: 2,
    },
  ];

  const nextDisabled = useMemo(() => {
    if (MOCK_SUBACCOUNT?.length === 0 || !tagLabelValue || !selectedOpt)
      return true;
    return false;
  }, [MOCK_SUBACCOUNT, tagLabelValue, selectedOpt]);

  const toNext = () => {
    toastTip("请先在子账户中存入资产", { type: "error" });
    setCurrStep(ADD_STEP.SAVE);
  };
  return (
    <Flex
      alignItems={"center"}
      flexDirection={"column"}
      w={["90%", "400px"]}
      justifyContent={"flex-start"}
      margin={"0 auto"}
    >
      <Text fontSize={"24px"} fontWeight={600}>
        {t("新增API")}
      </Text>

      <Box mt="20px" w={"100%"}>
        <Text fontSize={"14px"}>{t("选择子账户")}</Text>
        <BXNSelect
          style={{ marginTop: "10px" }}
          options={MOCK_SUBACCOUNT}
          handleSelect={(item) => setSelectedOpt(item)}
        />
      </Box>

      <Box mt="20px" w={"100%"}>
        <Text fontSize={"14px"}>{t("Api标签名")}</Text>
        <BXInput
          placeholder={t("自定义标签名")}
          mt="10px"
          maxLength={20}
          onChange={(e) => {
            setTagLabelValue(e.target.value);
          }}
        />
      </Box>

      <Flex mt={"30px"} w={"80%"}>
        <BXButton
          className="cancel"
          w={"30%"}
          onClick={() => navigate("/trade/subAccount")}
        >
          {t("UNForxvjDLCZdGrmWkX")}
        </BXButton>
        <BXButton
          className={nextDisabled ? "disabled" : ""}
          ml={"10px"}
          w={"70%"}
          onClick={() => toNext()}
        >
          {t("tOaRBVUJHpnSgDBrGON")}
        </BXButton>
      </Flex>

      <BalanceModal
        show={showBalanceTip}
        onCancel={() => setShowBalanceTip(false)}
      />
    </Flex>
  );
};

export default Create;
